export const ACTIVE_MENU = 'auctioneer-control-center-menu';
export const ACTIVE_AAPI_BEACON_FFROM = 'auctioneer-control-center-from';
export const MENU_PAST_SALES = 1;
export const MENU_FUTURE_SALES = 2;
export const MENU_CONTRACT = 3;
export const MENU_FILES = 4;
export const MENU_CONTACT = 5;
export const MENU_SUBSCRIPTIONS = 6;
export const AGREEMENT_ACCEPTING = 'auctioneer/AGREEMENT_ACCEPTING';
